<template>
    <TreatmentCategoriesList/>
</template>

<script>
import TreatmentCategoriesList from '../../components/treatment-categories/TreatmentCategoriesList';

export default {
  components: {
    TreatmentCategoriesList,
  },
};
</script>
